<template>
    <v-dialog v-model="handleDialog" width="1400" class="common-dialog" persistent>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <validation-observer ref="observer" v-slot="{ invalid }" >
            <form @submit.prevent="pushOk">
                <v-card color="#F4FEFB">
                    <v-card-title class="justify-center">
                        <h2 v-if="id">署名者編集</h2><h2 v-else>署名者追加</h2>
                    </v-card-title>
                    <v-card-text class="common-dialog-message display-flex">
                        <v-container style="width:50%; max-width:50%;">
                            <v-row>
                                <v-col cols="12" xl="4">
                                    <badge-component tile content="任　意">
                                        <label-component>氏名</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider rules="max:100" name="destination_user_name" v-slot="{ errors }">
                                        <v-text-field outlined clearable v-disabled-icon-focus required v-model="destination_user_name" :error-messages="errors" background-color="white"></v-text-field>
                                    </validation-provider>
                                </v-col>
                                <v-col cols="12" xl="4">
                                    <badge-component tile content="任　意">
                                        <label-component>メールアドレス</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider rules="email|max:255" name="destination_email_address" v-slot="{ errors }">
                                        <v-text-field required outlined clearable v-disabled-icon-focus v-model="destination_email_address" :error-messages="errors" background-color="white"></v-text-field>
                                    </validation-provider>
                                </v-col>
                                <v-col cols="12" xl="4">
                                    <badge-component tile content="任　意">
                                        <label-component>会社名</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider v-slot="{ errors }" name="destination_company_name" rules="max:50" >
                                        <v-text-field outlined clearable v-disabled-icon-focus v-model="destination_company_name" :error-messages="errors" autocomplete="new-name" background-color="white"></v-text-field>
                                    </validation-provider>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-container style="width:50%; max-width:50%;">
                            <v-tabs grow>
                                <v-tab active-class="white">契約先メンバー</v-tab>
                                <v-tab-item>
                                    <v-card>
                                        <v-card-text>
                                            <v-container class="search-container">
                                            <v-row style="height:80px;">
                                                <v-col class="display-flex">
                                                    <v-text-field
                                                        v-model="destination_search_name"
                                                        append-icon="mdi-magnify"
                                                        :height="20"
                                                        placeholder="氏名・会社名・メールアドレスでの検索"
                                                        outlined
                                                        background-color="white"
                                                        dense
                                                        hide-details
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="destination-member-area">
                                                    <table class="destination-member-table">
                                                        <tbody>
                                                            <tr 
                                                                v-for="destinationUserRecord in filterDestinationRecords" 
                                                                :key="destinationUserRecord.index" 
                                                                @click="selected_reflect(destinationUserRecord)"
                                                            >
                                                                <td>
                                                                    {{ destinationUserRecord.company }}
                                                                </td>
                                                                <td>
                                                                    {{ destinationUserRecord.name }}
                                                                </td>
                                                                <td style="display:none">
                                                                    {{ destinationUserRecord.email }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>

                                <v-tab  active-class="white">社内メンバー</v-tab>
                                <v-tab-item>
                                    <v-card>
                                        <v-card-text>
                                            <v-container class="search-container">
                                                <v-row style="height:80px;">
                                                    <v-col class="display-flex">
                                                        <v-text-field
                                                            v-model="user_search_name"
                                                            append-icon="mdi-magnify"
                                                            :height="20"
                                                            placeholder="氏名での検索(部分一致)"
                                                            outlined
                                                            dense
                                                            background-color="white"
                                                            hide-details
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="member-area">
                                                        <table class="membertable"><tbody>
                                                            <tr class="membertable-row" v-for="userRecord in filterUserRecords" :key="userRecord.index" @click="selected_user_reflect(userRecord)">
                                                                <td class="membertable-name">{{ userRecord.name }}</td>
                                                                <td>{{ userRecord.email }}</td>
                                                                <td class="membertable-company">{{ userRecord.company }}</td>
                                                            </tr>
                                                        </tbody></table>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs>
                        </v-container>
                    </v-card-text>
                    
                    <v-divider></v-divider>
                    
                    <v-card-actions class="justify-center grey lighten-4 pb-6">
                        <v-btn min-width="150px" class="white--text" color="red" large :disabled="invalid" @click="pushOk">
                            <slot name="ok-btn"></slot>
                        </v-btn>
                        <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false;">
                            <slot name="cancel-btn"></slot>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </validation-observer>
    </v-dialog>
</template>

<script>
  import { email, max } from 'vee-validate/dist/rules';
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
  
  extend('email', {
    ...email,
    message: '正しいメールアドレスをご入力ください',
  });

  extend('max', {
    ...max,
    message: '{length} 文字以内でご入力ください',
  });

export default {
    components: {
          ValidationProvider,
          ValidationObserver,
    },
    props: {
        sender: Object,
        currentSignerList: Array,
        currentIndex: Number,
        currentItem: Object,
        // ダイアログの開閉
        signerDialog: Boolean,
    },
    data() {
        return {
            item: null,
            destination_search_name: '',
            user_search_name: '',
            destinationUserRecords: [],
            userRecords: [],
            message: {
                success: false,
                text: '',
            },
        };
    },
    // 初期表示のデータ
    async created () {
        this.item = {
            id: this.currentItem.id?? '',
            destination_user_name: this.currentItem.destination_user_name?? '',
            destination_email_address: this.currentItem.destination_email_address?? '',
            destination_company_name: this.currentItem.destination_company_name?? '',
        };
        // 契約先メンバー検索
        await this.initdestinationUserRecord();
        // 社内メンバー検索
        await this.initUserRecord();
    },
    computed: {
        id: {
            get() {
                return this.item.id;
            },
        },
        destination_user_name: {
            get() {
                return this.item.destination_user_name;
            },
            set(value) {
                this.item.destination_user_name = value;
            }
        },
        destination_email_address: {
            get() {
                return this.item.destination_email_address;
            },
            set(value) {
                this.item.destination_email_address = value;
            }
        },
        destination_company_name: {
            get() {
                return this.item.destination_company_name;
            },
            set(value) {
                this.item.destination_company_name = value;
            }
        },
        filterDestinationRecords: function() { 
            if (!this.destination_search_name) {
                return this.destinationUserRecords;
            }
            let destUserRecords = this.destinationUserRecords.filter(
                function (destinationUserRecordsFiltered) {
                    return destinationUserRecordsFiltered.name.includes(this.destination_search_name) || destinationUserRecordsFiltered.company?.includes(this.destination_search_name) || destinationUserRecordsFiltered.email?.includes(this.destination_search_name);
                }, this);
            return destUserRecords;
        },
        filterUserRecords: function() { 
            if (!this.user_search_name) {
                return this.userRecords;
            }
            let userRecords = this.userRecords.filter(
                function (userRecordsFiltered) {
                    return userRecordsFiltered.name.includes(this.user_search_name);
                }, this);
            return userRecords;
        },
        handleDialog: {
            get() {
                return this.signerDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:signerDialog', value);
            }
        },
        isMessage: {
            get() {
                return this.message.text != '';
            },
            set(value) {
                if (!value) {
                    this.message.text = '';
                }
            }
        },
    },
    methods: {
        // 更新
        pushOk: function() {
            let self = this;
            this.$refs.observer.validate().then((result) => {
                if(result) {
                    if (self.item.destination_email_address != null && self.item.destination_email_address != '') {
                        let find = self.currentSignerList.find(item => item.destination_email_address == self.item.destination_email_address);
                        if (find != null && self.currentSignerList.indexOf(find) != self.currentIndex) {
                            self.message.text = "すでに宛先に設定されているメールアドレスです";
                            self.message.success = false;
                            return false;
                        }
                    }
                    // 親コンポーネントへの通知
                    self.$emit("clickOk", self.item);
                    self.handleDialog = false;
                }
            });
        },
        // 契約先メンバー検索
        async initdestinationUserRecord() {
            let self = this;
            await window.axios.get('/documents/document-management/template/contract_destination_members')
                .then(response => {
                    self.destinationUserRecords = response.data.records;
                });
        },
        // 社内メンバー検索
        async initUserRecord() {
            let self = this;
            await window.axios.get('/documents/document-management/template/users-search', {
                params: {
                    name: self.user_search_name,
                }
            }).then(
                response => (
                    self.userRecords = response.data.userRecords
                )
            );
        },
        // 契約先メンバー - 選択行の反映
        async selected_reflect(destinationUserRecord) {
            this.item.destination_user_name = destinationUserRecord.name;
            this.item.destination_email_address = destinationUserRecord.email;
            this.item.destination_company_name = destinationUserRecord.company;
        },
        // 社内メンバー - 選択行の反映
        async selected_user_reflect(userRecord) {
            this.item.destination_user_name = userRecord.name;
            this.item.destination_email_address = userRecord.email;
            this.item.destination_company_name = userRecord.company;
        },
    },
};
</script>

<style scoped>
    .confirm-message {
        text-align: center;
    }
    .search-container {
        border: 1px solid #aaa;
        border-radius: 6px;
    }
    .member-area {
        margin-top: -30px;
        overflow: auto;
        height: 350px;
    }
    .membertable {
        border-collapse: collapse;
        width: 620px;
    }
    .membertable-row {
        border-top: 1px solid #aaa;
        border-bottom: 1px solid #aaa;
    }
    .membertable-row:hover {
        cursor:pointer;
        background-color: #ddd;
        transition: all  0.3s ease;
    }
    .membertable-name {
        padding: 10px;
        width: 170px;
        font-weight: bold;
    }
    .membertable-company {
        display:none;
    }
    .display-flex {
        display: flex;
    }
    .destination-member-area {
        margin-top: -30px;
        overflow: auto;
        height: 350px;
    }
    .destination-member-table {
        border-collapse: collapse;
        width: inherit;
    }
    .destination-member-table tr {
        border-top: 1px solid #aaa;
        border-bottom: 1px solid #aaa;
    }
    .destination-member-table tr:hover {
        cursor:pointer;
        background-color: #ddd;
        transition: all 0.3s ease;
    }
    .destination-member-table td {
        padding: 10px;
    }
</style>